import { Component, ViewChild } from '@angular/core';
import { ExtratoService } from './extrato.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TableTransactionsComponent } from '../table-transactions/table-transactions.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-extrato',
  templateUrl: './extrato.component.html',
  styleUrls: ['./extrato.component.scss'],
})
export class ExtratoComponent {
  aReceber: number = 0;
  recebimento: number = 0;
  ticketMedioRecebimento: number = 0;
  conversao: number = 0;
  saque: number = 0;
  saquePendente: number = 0;
  saldoFinal: number = 0;

  extrato = new FormGroup({
    tipo: new FormControl<string>(''),
    status: new FormControl<string>(''),
    tipoBusca: new FormControl<string>(''),
    origem: new FormControl<string>(''),
    aplicacao: new FormControl<string>(''),
    responsavel: new FormControl<string>(''),
    initialDate: new FormControl<NgbDateStruct | null>(
      null,
      Validators.required
    ),
    endDate: new FormControl<NgbDateStruct | null>(null, Validators.required),
  });

  transactionTypes = [
    { name: 'common.general', value: '' },
    { name: 'common.deposit', value: 'DEPOSITO' },
    { name: 'common.withdraw', value: 'SAQUE' },
  ];
  statusList: any[] = [
    { name: 'Todos', value: '' },
    { name: 'Pendente', value: 'PENDENTE' },
    { name: 'Realizado', value: 'REALIZADO' },
    { name: 'Analise', value: 'ANALISE' },
  ];
  // originList: { name: string; value: string }[] = [];
  originList = [
    { name: 'Todos', value: '' },
    { name: 'Pix', value: 'PIX' },
    { name: 'Comissão', value: 'COMISSÃO' },
    { name: 'Cripto', value: 'CRIPTO' },
    { name: 'Taxa Bancária', value: 'TAXA BANCÁRIA' },
    { name: 'Reembolso', value: 'REEMBOLSO' },
    { name: 'Tef', value: 'TEF'}
  ];
  
  applicationList = [
    { name: 'Todos', value: ''},
    { name: 'common.web', value: 'WEB'},
    { name: 'common.api', value: 'API'}
  ];
  tipoBuscaList: any[] = [
    { name: 'common.description', value: 'personName' },
    { name: 'common.id', value: 'id' },
    { name: 'common.idempotencyKey', value: 'idempotencyKey' },
    { name: 'common.document', value: 'cpf' },
  ];

  public isFilterColapsed = false;
  public isSubmitted = false;
  public isLoaded: boolean = false;

  @ViewChild(TableTransactionsComponent) table!: TableTransactionsComponent;

  constructor(
    private extratoService: ExtratoService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    this.extrato.controls.initialDate.setValue({
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
    });
    this.extrato.controls.endDate.setValue({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    });
    this.extrato.controls.status.setValue('REALIZADO');
    this.extrato.controls.tipoBusca.setValue('personName')
    this.loadScreen();
  }

  loadScreen() {
    let dataInitial = this.extrato.controls.initialDate.value!;
    let dataFinal = this.extrato.controls.endDate.value!;
    let dateInitialFormat = `${dataInitial.year}-${dataInitial.month}-${dataInitial.day}`;
    let dateFinalFormat = `${dataFinal.year}-${dataFinal.month}-${dataFinal.day}`;
    let origin = this.extrato.controls.origem.value!.toUpperCase();
    let application = this.extrato.controls.aplicacao.value!
    let personName = this.extrato.controls.responsavel.value!
    let searchType = this.extrato.controls.tipoBusca.value!
    this.getEnum();
    this.extratoService
      .getDashBoardExtratoValues(dateInitialFormat, dateFinalFormat, origin, application, personName, searchType)
      .subscribe((value) => {
        this.aReceber = value.aReceber;
        this.recebimento = value.recebimento;
        this.ticketMedioRecebimento = value.ticketMedioRecebimento;
        this.conversao = value.conversao;
        this.saque = value.saque;
        this.saquePendente = value.saquePendente;
        this.saldoFinal = value.saldoFinal;
        this.isLoaded = true;
      });
  }

  getEnum(): void {
  this.extratoService.getEnum()               
    .then(resp => {
      this.originList = [
        { name: 'Todos', value: '' },
        ...resp.values.map((v: string) => ({ name: v, value: v }))
      ];
    });
} 
  

  buscar() {
    this.isSubmitted = true;
    this.isLoaded = false;

    let formStartDate = this.extrato.controls.initialDate.value!;
    let formEndDate = this.extrato.controls.endDate.value!;

    let startDate = new Date(
      formStartDate.year,
      formStartDate.month - 1,
      formStartDate.day
    );
    let endDate = new Date(
      formEndDate.year,
      formEndDate.month - 1,
      formEndDate.day
    );

    if (startDate > endDate) {
      this.toastr.error(
        'Data inicial deve ser menor ou igual a data final!',
        'Erro',
        {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        }
      );
      this.isLoaded = true;
      return;
    }

    if (this.extrato.invalid) {
      this.isLoaded = true;
      return;
    }

    this.table.page = 1;

    this.table.dataInitial = this.extrato.controls.initialDate.value!;
    this.table.dataFinal = this.extrato.controls.endDate.value!;
    this.table.selectedStatus = this.extrato.controls.status.value!;
    this.table.transactionType = this.extrato.controls.tipo.value!;
    this.table.selectedOrigin = this.extrato.controls.origem.value!.toUpperCase();
    this.table.selectedApplciation = this.extrato.controls.aplicacao.value!;
    this.table.personName = this.extrato.controls.responsavel.value!;
    this.table.searchType = this.extrato.controls.tipoBusca.value!;
    this.table.getTransactions();
    this.loadScreen();

    this.isSubmitted = false;
  }

  filterColapse() {
    this.isFilterColapsed = !this.isFilterColapsed;
  }

  downloadFile() {
    let dataInitial = this.extrato.controls.initialDate.value!;
    let dataFinal = this.extrato.controls.endDate.value!;

    let dateInitialFormat = new Date(
      dataInitial.year,
      dataInitial.month - 1,
      dataInitial.day
    );
    let dateFinalFormat = new Date(
      dataFinal.year,
      dataFinal.month - 1,
      dataFinal.day
    );
    this.extratoService
      .getCsvFile(
        dateInitialFormat,
        dateFinalFormat,
        this.extrato.controls.tipo.value!,
        this.extrato.controls.status.value!
      )
      .subscribe((value) => {
        let csvContent = decodeURIComponent(escape(atob(value)));
        const a = document.createElement('a');
        const blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;',
        });
        const url = window.URL.createObjectURL(blob);
        let company = this.authService.getCompany();
        a.href = url;
        a.download = `${company}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
  }
}
